var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Togo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffeb3b",
    d: "M43.598,28H25H4.402c0.601,2.961,1.873,5.671,3.626,8h31.946C41.725,33.671,42.997,30.961,43.598,28 z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffeb3b",
    d: "M25,20h18.598c-0.601-2.961-1.873-5.671-3.626-8H25V20z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    d: "M39.973,12C36.512,7.401,31.124,4.354,25,4.05V12H39.973z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    d: "M39.973,36H8.027c3.649,4.85,9.436,8,15.973,8S36.323,40.85,39.973,36z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    d: "M25,28h18.598C43.861,26.707,44,25.37,44,24s-0.139-2.707-0.402-4H25V28z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff3d00",
    d: "M25,20v-8V4.05C24.667,4.034,24.338,4,24,4C12.954,4,4,12.954,4,24c0,1.37,0.139,2.707,0.402,4H25 V20z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15,11.039L16.488,16h4.82l-3.898,2.457l1.488,4.582L15,20.207l-3.898,2.832l1.488-4.582L8.691,16 h4.82L15,11.039z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Togo);
export default __webpack_public_path__ + "static/media/icons8-togo.b597e856fcc65644d2355f156ff7b1f8.svg";
export { ForwardRef as ReactComponent };